import convertPersonaToRecipientViewState from './convertPersonaToRecipientViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import processGetGroupInfoResult from 'owa-readwrite-recipient-well/lib/actions/processGetGroupInfoResult';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import updateIsExpanding from '../actions/updateIsExpanding';
import { getGroupInfo } from 'owa-readwrite-recipient-well/lib/services/getGroupInfo';
import shouldExpandGroup from 'owa-recipient-common/lib/utils/shouldExpandGroup';
import { logUsage } from 'owa-analytics';
import { getAggregationBucket } from 'owa-analytics-actions';

export default async function expandGroup(
    recipientToExpand: ReadWriteRecipientViewState
): Promise<ReadWriteRecipientViewState[]> {
    updateIsExpanding(recipientToExpand, true);
    let groupResponse = await getGroupInfo(
        recipientToExpand.persona.PersonaId,
        recipientToExpand.persona.ADObjectId,
        recipientToExpand.persona.EmailAddress
    );

    updateIsExpanding(recipientToExpand, false);
    const membersCount =
        groupResponse && groupResponse.MembersCount ? groupResponse.MembersCount : 0;
    let expandedEmails: FindRecipientPersonaType[] = [];
    const shouldExpand = await shouldExpandGroup(membersCount);

    if (shouldExpand) {
        processGetGroupInfoResult(expandedEmails, groupResponse);
    }

    // Log that group recipient has been expanded
    logUsage('RWRecipientGroupExpand', {
        size: getAggregationBucket({
            value: membersCount,
            exactMatches: [],
            buckets: [25, 50, 75, 100, 125, 150, 175, 200],
        }),
        shouldExpand,
    });

    return convertPersonaToRecipientViewState(expandedEmails);
}
